import type { RouteRecordRaw } from 'vue-router'
import TrainingIndex from '@/views/frontDesk/training/index.vue'
import TrainingDetail from '@/views/frontDesk/training/detail.vue'
import TrainingTabel from '@/views/frontDesk/training/tabel.vue'
import TrainingMemberTabel from '@/views/frontDesk/training/memberTabel.vue'

// 拎包培训
export const TrainingRoute: Array<RouteRecordRaw> = [
  {
    path: 'trainingIndex',
    name: 'TrainingIndex',
    meta: {
      title: '拎包培训' 
    },
    component: TrainingIndex
  },
  {
    path: 'trainingIndex/trainingDetail/:id',
    name: 'TrainingDetail',
    meta: {
      title: '培训详情' 
    },
    component: TrainingDetail
  },
  {
    path: 'trainingIndex/trainingTabel/:id',
    name: 'TrainingTabel',
    meta: {
      title: '非会员培训报名' 
    },
    component: TrainingTabel
  },
  {
    path: 'trainingIndex/trainingMemberTabel/:id',
    name: 'TrainingMemberTabel',
    meta: {
      title: '会员培训报名' 
    },
    component: TrainingMemberTabel
  },
]

export default TrainingRoute